import Vue from 'vue';
import Component from 'vue-class-component';
import Moment from 'moment';
import { Holiday } from '@/tools/models/holiday.model';
import { _SCHOOL_CALENDAR_STORE, SCHOOL_DATE_TYPE, SCHOOL_DAY_STATUS } from '@/tools/values/school-calendar.values';
import { WEEK_DAYS } from '@/values/general.values';
import { BUILDER_EVENT_TYPES } from '@/courses/values/courses.values';
import { EdContextMenuModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';

@Component({})
export default class CalendarMixin extends Vue {

  get businessDays(): Holiday[] {
    let holidays: Holiday[] = this.$store.state.SchoolCalendarStore.holidays;
    return holidays.filter(h => h.status == SCHOOL_DAY_STATUS.IGNORED);
  }

  get colors() {
    return this.$store.state.SchoolCalendarStore.preferences.colors;
  }

  get customEventColors(): Record<string, string> {
    return {
      [BUILDER_EVENT_TYPES.CONTENT]: 'var(--ed-color-main)',
      [BUILDER_EVENT_TYPES.FILLER]: 'var(--ed-color-green-dark)',
      [SCHOOL_DATE_TYPE.US_HOLIDAYS]: 'var(--ed-color-warning)',
      [BUILDER_EVENT_TYPES.DAY_OFF]: 'var(--ed-color-gray-light-plus)',
      [BUILDER_EVENT_TYPES.FUN]: 'var(--ed-color-gray-lighter)',
      [SCHOOL_DATE_TYPE.SCHOOL_CALENDAR]: 'var(--ed-color-gray-medium-darker)',
    }
  }

  protected showEdContextMenu(text: string, position: {x: number, y: number}): void {
    this.$EdContextMenu.show(new EdContextMenuModel({
      position: { x: position.x, y: position.y },
      options: [{ text }],
      darkMode: true,
    }));
  }

  protected closeEdContextMenu(): void {
    this.$EdContextMenu.close();
  }

  getIsSchoolDay(date, schoolDays) {
    let response = false;
    schoolDays.forEach(calendar => {
      if(calendar.dates.includes(date)) {
        response = true;
      }
    });
    return response;
  }

  validateSchoolDay(date, schoolDays) {
    let style: any = {};
    /* Validate school day */
    let i = schoolDays.findIndex(sd => {
      let found = sd.dates.find(d => {
        return d == date;
      });
      if(found) return true;
    });
    if(i != -1) {
      style.backgroundColor = `${schoolDays[i].color}20 !important`;
    }
    
    /* Validate if the date is in working days or business days */
    let business = this.businessDays.find(b => b.startDate == date);
    if(!business && i == -1) {
      let dayOfWeek = WEEK_DAYS[Moment(date).get('day')];
      let workingDays = this.$store.state.SchoolCalendarStore.workingDays;
      let schoolDay = workingDays.find(wd => {
        return wd.label == dayOfWeek;
      });
      if(schoolDay) {
        if(!schoolDay.checked) {
          style.color = 'var(--ed-color-gray-light-plus)';
        }
      }
    }
    return style;
  }

  validateCurrentDay(date) {
    let style: any = {};
    if(date === Moment().format('YYYY-MM-DD')) {
      style = {
        backgroundColor: `${this.colors.CURRENT_DATE} !important`,
        color: 'white'
      };
    }
    return style;
  }

  getSchoolDay(date, schoolDays) {
    let j = 0;
    let i = schoolDays.findIndex(sd => {
      let found = sd.dates.find(d => {
        return d == date;
      });
      if(found) {
        j = sd.dates.indexOf(found);
        return true;
      }
    });
    return { index: i, day: j }
  }

}